import { useEffect, useRef, useState } from "react";
import { Smile } from "lucide-react";

let cachedPicker = null;
const loadPicker = () => {
  if (!cachedPicker) cachedPicker = import("emoji-picker-react");
  return cachedPicker;
};

/**
 * Inline emoji picker trigger. Click to toggle a popover containing the full
 * Facebook-style emoji set (categories, search, skin tones via emoji-picker-react).
 * Calls `onEmojiClick(emojiChar)` with the selected character.
 */
export default function EmojiPickerButton({ onEmojiClick, testid = "emoji-picker-btn", buttonClass = "" }) {
  const [open, setOpen] = useState(false);
  const [Picker, setPicker] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    if (open && !Picker) loadPicker().then((mod) => setPicker(() => mod.default));
  }, [open, Picker]);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    if (open) document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return (
    <div ref={ref} className="relative inline-block">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={`p-2 text-foreground/60 hover:text-primary rounded-sm ${buttonClass}`}
        title="Add emoji"
        data-testid={testid}
      >
        <Smile size={18} strokeWidth={1.5} />
      </button>
      {open && (
        <div className="absolute z-50 bottom-full right-0 mb-2 shadow-2xl rounded-md overflow-hidden" data-testid={`${testid}-panel`}>
          {Picker ? (
            <Picker
              onEmojiClick={(emojiData) => { onEmojiClick(emojiData.emoji); setOpen(false); }}
              theme="dark"
              width={340}
              height={420}
              previewConfig={{ showPreview: false }}
              searchPlaceHolder="Search emojis..."
            />
          ) : (
            <div className="bg-card text-foreground p-6 w-[340px] text-center text-sm">Loading emojis…</div>
          )}
        </div>
      )}
    </div>
  );
}
